import { type MutationHookOptions, useMutation } from "@apollo/client";
import { StartEntrypointPullMutation } from "../graphql/mutations";
import type {
  StartEntrypointPullMutationType,
  StartEntrypointPullMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useStartEntrypointPullMutation = (
  options?: MutationHookOptions<
    StartEntrypointPullMutationType,
    StartEntrypointPullMutationVariablesType
  >
) => {
  return useMutation<
    StartEntrypointPullMutationType,
    StartEntrypointPullMutationVariablesType
  >(StartEntrypointPullMutation, options);
};
